const qrTranslator = require('./qr-translation');

class QRBus
{
    /**
	 * Instantiate a QRBus instance.
	 *
	 * @param {object} settings (optional) Settings to use.
	 */
    constructor(settings)
    {
        this._QREventHandler = (event) => {};
        if (settings.eventHandler)
        {
            this._QREventHandler = settings.eventHandler;
        }
        this._GetByQRCode = (entity, qr) => { return { QRCode: qr } };
        if (settings.getByQRCode)
        {
            this._GetByQRCode = settings.getByQRCode;
        }
        this.receiveScan = this._debounce(this._receiveScanInternal);
    }

    /**
     * Simple debounce implementation.
     * @param {Function} func 
     * @returns 
     */
    _debounce(func, time) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), time || 200);
        };
    }

    /**
     * A function that handles a scanning instance from a scanner and propogates an event from it.
     * @param {String} code - A scanned QR Code.
     */
    async _receiveScanInternal(code)
    {
        /**  
         * @typedef {Object|Array<String>} Payload
         * @property {String} [QRCode] - QRCode value of the item scanned.
         */
        /**  
         * @typedef {Object} QREvent
         * @property {Payload} payload - payload for the event.
         * @property {String} event - the action for the ui to consume from the event.
         */
        /** @type QREvent */
        const QREvent = 
        {
            payload: { QRCode: code },
            event: 'no-action'
        };

        const translation = qrTranslator.translateQRCode(code);
        console.info('[QRBus] Translated QR Code: ', translation);

        if (translation.type === 'Action')
        {
            QREvent.event = translation.action;
            QREvent.payload = translation.actionTokens;
        }
        else
        {
            try
            {
                const entity = await this._GetByQRCode(translation.type, translation.code);
                if (entity.Error)
                {
                    throw new Error('Found no matching items.');
                }
                QREvent.payload = entity;
                QREvent.event = `scanned-${ translation.type }`;
            }
            catch (err)
            {
                console.info(`[QRBus] Failed to fetch ${ translation.type } with QR Code: ${ translation.code }`);
            }
        }

        this._QREventHandler(QREvent);
    }
}

module.exports = 
{
    QRBus
};